import type { ReactNode } from "react";

/** Become-theme section kicker: thin sand rule + spaced Oswald caps label. */
const SectionLabel = ({
  children,
  tone = "light",
}: {
  children: ReactNode;
  tone?: "light" | "dark";
}) => {
  const dark = tone === "dark";
  return (
    <div className={`border-t pt-3 ${dark ? "border-white/30" : "border-hxp-sand-dark"}`}>
      {/* A real h2 (styled as the kicker) so every page has a proper outline:
          h1 page title, h2 section labels, h3 items. */}
      <h2
        className={`btn-caps text-xs tracking-[0.18em] ${
          dark ? "text-hxp-cream" : "text-foreground"
        }`}
      >
        {children}
      </h2>
    </div>
  );
};

export default SectionLabel;
